export const themaDetailsPageContent = {
  tooltips: {
    missingAblaufTemplate: 'Kein Ablauf in CServ gepflegt.',
    unsupportedStrukturellesFormat: 'Für dieses Format dürfen keine Objekte angelegt werden.',
    missingLeistungstemplates:
      'Stelle sicher, dass die Leistung(en) durch das Produkt-Management freigegeben sind oder wechsle auf manuellen Ausschreibungsprozess.',
  },
} as const;
